import { DispatchAction } from "../../lib/dispatch";
import { None } from "../../lib/misc/option";
export class BaseActionWithNav extends DispatchAction {
    constructor(name) { super(name); }
    on_invalid_message() {
        let val = super.on_invalid_message();
        val.navigate = None.instance();
        return val;
    }
}
